import { createSelector } from 'reselect';
import isNil from 'lodash/isNil';
import has from 'lodash/has';
import { mapValues, pick } from 'lodash';
import { getResourceEntity } from 'js/lib/PipelineUtils';

export const pipelineItemsSelector = createSelector(
  [
    (state: any) => state.entities,
    (state: any) => state.pipelines.branches,
    (state: any, item: any) => item,
  ],
  (entities, branches, item) => {
    const { flowNodes, sources } = entities;

    const flow = flowNodes[item.origin_node_id];
    const source = sources[flow?.data_source_id];
    const rootKey = source?.flow_node_id;

    const branch =
      !isNil(rootKey) && has(branches, rootKey) ? branches[rootKey] : { items: [], edges: [] };

    return mapValues(pick(flowNodes, branch.items), (flowNode) =>
      getResourceEntity(flowNode, entities),
    );
  },
);
